export const initUiBanner = () => {
  const bannerCloseSelector = $(".js-banner-close");
  const readMoreSelector = $(".js-banner-read-more");
  const readLessSelector = $(".js-banner-read-less");
  const bannerSelector = $(".ui-banner");
  const EXPANDED = "expanded";
  const IS_VISIBLE = "is-visible";

  if (
    bannerCloseSelector.length ||
    readMoreSelector.length ||
    readLessSelector.length ||
    bannerSelector.length
  ) {
    setTimeout(() => {
      bannerSelector.addClass(IS_VISIBLE);
    }, 4000);

    bannerCloseSelector.each(function() {
      $(this).on("click", function() {
        $(this)
          .closest(bannerSelector)
          .removeClass(IS_VISIBLE);
      });
    });

    readMoreSelector.each(function() {
      $(this).on("click", function(e) {
        e.preventDefault();
        bannerSelector.addClass(EXPANDED);
      });
    });

    readLessSelector.each(function() {
      $(this).on("click", function(e) {
        e.preventDefault();
        bannerSelector.removeClass(EXPANDED);
      });
    });
  }
};
